import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { get } from 'lodash'
import { Unauthorized, Forbidden, NotFound, InternalServer } from '../view/'

export const ErrorHandler: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const location = useLocation()
  const navigate = useNavigate()

  // history.replace に 渡す location.state は画面リロードではリフレッシュされないため、リロード時に強制的に location.state を取り除いている。
  React.useEffect(() => {
    if (location.state) {
      navigate(location.pathname + location.search, { replace: true })
    }
  }, [])

  const statusCode = get(location.state, 'errorStatusCode');
  if (statusCode === 401) {
    return (
      <Unauthorized
        showRedirectToLogin={
          get(location.state, 'showRedirectToLogin') ?? false
        }
      />
    )
  } else if (statusCode === 403) {
    return <Forbidden />
  } else if (statusCode === 404) {
    return <NotFound />
  } else if (statusCode === 500) {
    return <InternalServer />
  } else {
    return children
  }
}
